import React from 'react';

const SPARKLES = ['✦', '✧', '✦', '✧'];

export default function () {
    return (
        <div className='student-intro-mascot'>
            <div className='mascot-float'>
                <span className='mascot-ring ring-0' aria-hidden='true'/>
                <span className='mascot-ring ring-1' aria-hidden='true'/>
                <div className='mascot-badge'>
                    <img
                        src={`${process.env.PUBLIC_S3_ASSETS_URL}/application/icon_login_student.svg`}
                        alt='Three smiling students'
                    />
                </div>
                {SPARKLES.map((sparkle, index) => (
                    <span key={index} className={`mascot-sparkle sparkle-${index}`} aria-hidden='true'>{sparkle}</span>
                ))}
            </div>
            <div className='mascot-shadow' aria-hidden='true'/>
        </div>
    );
}
